import { render, staticRenderFns } from "./Pagination2.vue?vue&type=template&id=3e26b15b&scoped=true"
import script from "./Pagination2.vue?vue&type=script&lang=js"
export * from "./Pagination2.vue?vue&type=script&lang=js"
import style0 from "./Pagination2.vue?vue&type=style&index=0&id=3e26b15b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e26b15b",
  null
  
)

export default component.exports